<template>
  <div>
    <div class="m_flex_row" style="margin-left:10px;margin-top:30px;margin-bottom:30px">
      <div class="m_flex_column" style="width:100px;" v-if="!onlyShow">{{title}}:</div>
      <a-button class="editable-add-btn" @click="SS_handleAdd" v-if="!onlyShow">新增一条{{title}}</a-button>
    </div>
    <a-table
      :columns="SS_columns"
      :data-source="SS_data"
      bordered
      style="margin:30px;"
      :pagination="false"
    >
      <template v-for="col in ['value']" :slot="col" slot-scope="text, record, index">
        <div :key="col">
          <a-input
            v-if="record.editable"
            style="margin: -5px 0"
            :value="text"
            @change="e => SS_handleChange(e.target.value, record.key, col)"
          />
          <template v-else>{{ text }}</template>
        </div>
      </template>
      <template slot="operation" slot-scope="text, record, index" v-if="!onlyShow">
        <div class="editable-row-operations">
          <span v-if="record.editable">
            <a @click="() => SS_save(record.key)">保存</a>
            <a-divider type="vertical" />
            <a @click="() => SS_cancel(record.key)">取消</a>
          </span>
          <span v-else>
            <a :disabled="SS_editingKey !== ''" @click="() => SS_edit(record.key)">编辑</a>
            <a-divider type="vertical" />
            <a :disabled="SS_editingKey !== ''" @click="() => SS_delete(record.key)">删除</a>
          </span>
        </div>
      </template>
    </a-table>
  </div>
</template>

<script>
import request from "@/utils/request";
export default {
  name: "ProjectAddShow",
  props: {
    SS_data: Array,
    title: String,
    onlyShow: Boolean
  },
  data() {
    return {
      count: 0,
      SS_columns: this.onlyShow
        ? [
            {
              title: this.title,
              dataIndex: "value",
              width: "80%",
              scopedSlots: { customRender: "value" }
            }
          ]
        : [
            {
              title: this.title,
              dataIndex: "value",
              width: "80%",
              scopedSlots: { customRender: "value" }
            },
            {
              title: "操作",
              dataIndex: "operation",
              scopedSlots: { customRender: "operation" }
            }
          ],
      SS_cacheData: [
        {
          value: "mark",
          key: "mark"
        }
      ],
      SS_editingKey: ""
    };
  },
  methods: {
    SS_handleAdd() {
      const { count, SS_data } = this;
      const newData = {
        key: count+1,
        value: ``,
        editable:true
      };
      let SS_data2 = [...SS_data, newData];
      console.log("SS_data2==?",SS_data2)
      this.count = count + 1;
      this.$emit("update", SS_data2, res => {
        console.log("回调返回", res,this.SS_data);
        // this.SS_edit(count);
      });
    },
    SS_edit(key) {
      console.log("编辑可以", key, this.SS_data);
      const newData = [...this.SS_data];
      const target = newData.filter(item => key === item.key)[0];
      this.SS_editingKey = key;
      if (target) {
        target.editable = true;
        console.log("编辑可以2", key, newData);
        this.$emit("update", newData, res => {
        console.log("回调返回", res,this.SS_data);
        // this.SS_edit(count);
      });
      }
    },
    SS_delete(key) {
      const newData = [...this.SS_data];
      const target = newData.filter(item => key !== item.key);
      this.$emit("update", target, res => {
        console.log("回调返回", res,this.SS_data);
        // this.SS_edit(count);
      });
      this.SS_cacheData = target;
    },
    SS_handleChange(value, key, column) {
      const newData = [...this.SS_data];
      const target = newData.filter(item => key === item.key)[0];
      if (target) {
        target[column] = value;
        this.$emit("update", newData, res => {
        console.log("回调返回", res,this.SS_data);
        // this.SS_edit(count);
      });
        // this.SS_data = newData;
      }
    },
    SS_save(key) {
      const newData = [...this.SS_data];
      const newCacheData = [...this.SS_cacheData];
      const target = newData.filter(item => key === item.key)[0];
      const targetCache = newCacheData.filter(item => key === item.key)[0];
      console.log("this.SS_cacheData ", this.SS_cacheData);
      console.log("newCacheData ", newCacheData);
      if (target && newCacheData) {
        delete target.editable;
        // this.SS_data = newData;
        this.$emit("update", newData, res => {
        console.log("回调返回", res,this.SS_data);
        // this.SS_edit(count);
      });
        // if(newCacheData):
        // Object.assign(targetCache, target);
        this.SS_cacheData = newData;
      }
      this.SS_editingKey = "";
      console.log("SS_editingKey", this.SS_editingKey);
    },
    SS_cancel(key) {
      const newData = [...this.SS_data];
      const target = newData.filter(item => key === item.key)[0];
      this.SS_editingKey = "";
      console.log("SS_editingKey", key, this.SS_editingKey);
      console.log("SS_editingKey-target", target);
      if (target) {
        Object.assign(
          target,
          this.SS_cacheData.filter(item => key === item.key)[0]
        );
        delete target.editable;
        // this.SS_data = newData;
        this.$emit("update", newData, res => {
        console.log("回调返回", res,this.SS_data);
        // this.SS_edit(count);
      });
      }
    }
  }
};
</script>

<style>
</style>